import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import PageLayout from '../components/PageLayout';

const PageTitle = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '3rem',
  color: '#1a1a1a',
  marginBottom: '2rem',
  textAlign: 'center',
});

const StyledPaper = styled(Paper)({
  padding: '3rem',
  marginBottom: '2rem',
  backgroundColor: '#fff',
  boxShadow: 'none',
  border: '1px solid #eee',
  borderRadius: '8px',
  textAlign: 'center',
});

const StyledText = styled(Typography)({
  fontSize: '1.2rem',
  lineHeight: '1.8',
  color: '#333',
  marginBottom: '1.5rem',
});

const EmailText = styled(Typography)({
  fontSize: '1.5rem',
  color: '#1a1a1a',
  fontFamily: 'Cormorant Garamond, serif',
  marginTop: '2rem',
});

const ContactPage = () => {
  return (
    <PageLayout>
      <Container>
        <Box sx={{ py: 8 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <PageTitle>Contact Us</PageTitle>
            <StyledPaper>
              <StyledText>
                For any inquiries about our jewelry, custom pieces, or services,
                please email us at:
              </StyledText>
              <EmailText>
                customconnectjewelry@gmail.com
              </EmailText>
              <StyledText sx={{ mt: 4 }}>
                We aim to respond to all inquiries within 2 business days.
              </StyledText>
            </StyledPaper>
          </motion.div>
        </Box>
      </Container>
    </PageLayout>
  );
};

export default ContactPage;
